<template>
    <div>
        <div class="columns m-0">
            <div class="column is-two-fifths-desktop is-one-fifth-fullhd p-0">
                <label class="label" for="test-name-input">
                    {{ trans.edit_form.name_input_label }}
                </label>
            </div>
            <div
                class="column p-0 control has-icons-right"
                :class="{ 'is-loading': isNameChangeInProgress }"
            >
                <input
                    class="input"
                    type="text"
                    id="test-name-input"
                    :disabled="!isCanEdit"
                    v-model="testBeingEdited.name"
                >
                <span
                    v-show="isNameChanged && !isNameChangeInProgress"
                    class="icon is-small is-right has-text-success"
                >
                        <i v-if="!error" class="fas fa-check"></i>
                        <i v-if="error" class="fas fa-cross"></i>
                    </span>
            </div>
        </div>
        <div class="columns mx-0 mb-0 mt-1">
            <div class="column is-two-fifths-desktop is-one-fifth-fullhd p-0">
                <label class="label">
                    {{ trans.edit_form.instruction_input_label }}
                </label>
            </div>
            <div
                class="column p-0 control has-icons-right"
                :class="{ 'is-loading': isInstructionChangeInProgress }"
            >
                <test-tinymce-editor v-model="testBeingEdited.instruction" :disabled="!isCanEdit"/>
                <span
                    v-show="isInstructionChanged && !isInstructionChangeInProgress"
                    class="icon is-small is-right has-text-success"
                >
                        <i v-if="!error" class="fas fa-check"></i>
                        <i v-if="error" class="fas fa-cross"></i>
                    </span>
            </div>
        </div>
        <div class="columns mx-0 mb-0 mt-1">
            <div class="column is-two-fifths-desktop is-one-fifth-fullhd p-0">
                <label class="label">
                    {{ trans.edit_form.activating.label }}
                </label>
            </div>
            <div
                class="column p-0 control has-icons-right align-center"
                :class="{ 'is-loading': isActiveChangeInProgress }"
            >
                <toggle-button
                    :title="trans.edit_form.activating.label"
                    v-model="testBeingEdited.is_active"
                    :is-disabled="isDisableActivateTest || !isCanEdit"
                />
                <span class="ml-1 is-danger" v-if="!isHasQuestions">{{ trans.edit_form.activating.not_questions_error }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import ToggleButton from "../../../../utils/forms/ToggleButton";
import QuestionTinymceEditor from "../questions/QuestionTinymceEditor";

export default {
    name: "TestEditMainTab",
    components: {
        ToggleButton,
        QuestionTinymceEditor,
    },
    data() {
        return {
            nameChangeTimeout: null,
            isNameChanged: false,
            isNameChangeInProgress: false,
            instructionChangeTimeout: null,
            isInstructionChangeInProgress: false,
            isInstructionChanged: false,
            isActiveChangeInProgress: false,
            error: null,
        }
    },
    computed: {
        ...mapGetters('tests', [
            'testBeingEdited',
            'trans',
            'testSettings',
            'isCanEdit',
        ]),
        isHasQuestions() {
            return Object.keys(this.testBeingEdited.questions).length > 0;
        },
        isDisableActivateTest() {
            return this.isActiveChangeInProgress || !this.isHasQuestions;
        }
    },
    watch: {
        'testBeingEdited.name': function (value) {
            this.isNameChangeInProgress = true;

            clearTimeout(this.nameChangeTimeout);

            this.nameChangeTimeout = setTimeout( () => {
                this.updateTest(this.testBeingEdited)
                    .then(() => {})
                    .catch((error) => {
                        this.error = error;
                    })
                    .finally(() => {
                        this.isNameChanged = true;
                        this.isNameChangeInProgress = false;
                    });
            }, 1000);
        },
        'testBeingEdited.instruction': function (value) {
            this.isInstructionChangeInProgress = true;

            clearTimeout(this.instructionChangeTimeout);

            this.instructionChangeTimeout = setTimeout( () => {
                this.updateTest(this.testBeingEdited)
                    .then(() => {})
                    .catch((error) => {
                        this.error = error;
                    })
                    .finally(() => {
                        this.isInstructionChanged = true;
                        this.isInstructionChangeInProgress = false;
                    });
            }, 1000);
        },
        'testBeingEdited.is_active': function (value) {
            this.isActiveChangeInProgress = true;
            this.updateTest(this.testBeingEdited)
                .then(() => {})
                .catch((error) => {
                    this.error = error;
                })
                .finally(() => {
                    this.isActiveChangeInProgress = false;
                });
        },
    },
    methods: {
        ...mapActions('tests', [
            'updateTest',
        ]),
    }
}
</script>

<style scoped lang="scss">
@import '../../../../../../sass/variables';

.bulma .test-edit-form .tabs-container .tabs-details {
    .column {
        display: flex;
    }

    .label {
        font-size: 1.2rem;
        font-weight: 600;
        line-height: 19px;
        text-align: left;
        min-width: 137px;
        align-self: center;

        &_min {
            font-size: 1rem;
        }
    }

    .test-question-list-label {
        margin: 25px 0 20px 0;
    }

    .field-label {
        margin-right: 14px;
    }

    #test-name-input {
        height: 40px;
        border: 1px solid $tests-light-grey;
        box-sizing: border-box;
        border-radius: 6px;
        box-shadow: none;
    }
}
</style>